// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_aub","icon":"styles_icon__FYPJ1"};